import React, { PureComponent, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './CambiarContrasenaPage.css';
import { SiteRutas, ImagenesRutas } from '../../request/RutasConfig';
import { Cambiar_Contrasena_Request } from '../../request/LoginRequest';
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { establecerUsuarioConectado } from '../../store/usuario/actions';

class CambiarContrasenaPage extends PureComponent {
    state = {
        currentPass: '',
        newPass: '',
        confirmPass: ''
    }     

    componentDidMount() {
        if (this.props.activo_AD) {
            this.props.history.replace(SiteRutas.Home);
        }
    }

    onChangeInput = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onClickBtnCancel = () => {  
        this.props.history.replace(SiteRutas.Home);
    }

    onClickBtnSubmit = (event) => {
        event.preventDefault();
        this.cambiarContrasena();
    }

    cambiarContrasena = async () => {
        const { currentPass, newPass } = this.state;
        const resultado = this.validarDatosForm();
        if (resultado) {
            Notificacion.error(resultado);
        } else {
            const response = await Cambiar_Contrasena_Request(this.props.token, this.props.login, currentPass, newPass);
            if (response.Exitoso) {
                Notificacion.success("Cambio de contraseña exitoso.");
                this.props.establecerUsuarioConectado(false);
                this.props.history.replace(SiteRutas.Login);
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    validarDatosForm = () => {
        const { currentPass, newPass, confirmPass } = this.state;
        if (!this.props.login || !currentPass || !newPass || !confirmPass) {
            return 'Faltan datos para poder continuar con el proceso.';
        }
        if (newPass !== confirmPass) {
            return 'La contraseña nueva no coincide con la confirmación de la misma.';
        }
        return '';
    }

    render() {
        const divStyle = {
            background: 'url(' + ImagenesRutas.Fondo_Login + ') no-repeat center center fixed',
            backgroundSize: 'cover'
        };

        return (
            <div style={divStyle} className="menu_container MainContainer">
                <div className="container">
                    <div className="pull-right">
                        <img className="logo_ld small" src={ImagenesRutas.Logo_LD_Blanco} alt="LogicalDataLogo" />
                    </div>
                    <div className="login_bg">
                        <p className="title">Express Web</p>
                        <h1 className="h1 text-center">Cambiar Contraseña</h1>
                        <div className="row">
                            <div className="col-12 col-md-10 offset-md-1">
                                <form id="frmCambiarContrasena">
                                    <fieldset>
                                        <legend></legend>
                                        <p>Por favor ingrese sus credenciales para cambiar su contrase&ntilde;a.</p>

                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='text' className='login' name='user' title='Nombre de Usuario' value={this.props.login} disabled readOnly />
                                            </span>
                                        </div>
                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='password' className='login' name='currentPass' title='Contraseña' placeholder='Contraseña' onChange={this.onChangeInput} />
                                            </span>
                                        </div>
                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='password' className='login' name='newPass' title='Nueva Contraseña' placeholder='Nueva Contraseña' onChange={this.onChangeInput} />
                                            </span>
                                        </div>
                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='password' className='login' name='confirmPass' title='Confirmar Contraseña' placeholder='Confirmar Contraseña' onChange={this.onChangeInput} />
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <button type="button" title="Cancelar" className="btn btn-light float-left" onClick={this.onClickBtnCancel}>Cancelar</button>
                                            </div>

                                            <div className="col-6">
                                                <button type="button" title="Cambiar" onClick={this.onClickBtnSubmit} className="btn btn-light float-right">Cambiar</button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        login: state.usuario.login,
        activo_AD: state.usuario.activo_AD
    };
};

export default connect(mapStateToProps, { establecerUsuarioConectado })(withRouter(memo(CambiarContrasenaPage)));
